import { render, staticRenderFns } from "./SSE.vue?vue&type=template&id=6d6e1b5b"
import script from "./SSE.vue?vue&type=script&lang=js"
export * from "./SSE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6e1b5b')) {
      api.createRecord('6d6e1b5b', component.options)
    } else {
      api.reload('6d6e1b5b', component.options)
    }
    module.hot.accept("./SSE.vue?vue&type=template&id=6d6e1b5b", function () {
      api.rerender('6d6e1b5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SSE/SSE.vue"
export default component.exports